class TokenManager {
  private static instance: TokenManager;
  private _accessToken: string | null = null;

  private constructor() {
    // private constructor in order not to be able call new TokenManager() outside
  }

  public static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  public setAccessToken(token: string): void {
    this._accessToken = token;
  }

  public getAccessToken(): string | null {
    return this._accessToken;
  }
}

export default TokenManager;
